// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-form-fields[data-v-d70ce7f6]{border-radius:8px;background:#fff;margin-bottom:12px}.panel-form-fields h3 i[data-v-d70ce7f6]{float:right}", ""]);
// Exports
module.exports = exports;
